var map = {
	"./3rd-party-logos/meitav.svg": "7919",
	"./Share button.svg": "16c7",
	"./alert_icon.svg": "683e",
	"./altshuler/altshuler-success.png": "5e4a",
	"./altshuler/dashboard-logo.svg": "78a9",
	"./altshuler/into-page-logo.svg": "2b16",
	"./ambassadors/ambassador-page-header.svg": "8de5",
	"./ambassadors/ambassadors-header-color.svg": "8ab4",
	"./ambassadors/ambassadors-page-header-150-benefit.svg": "45e1",
	"./ambassadors/ambassadors-page-header-50-percent-benefit.svg": "7502",
	"./ambassadors/ambassadors-page-header.svg": "e748e",
	"./ambassadors/ambassadors-popup-header.svg": "db4b",
	"./ambassadors/competition-card-background.svg": "95e3",
	"./ambassadors/hever-header.svg": "2037",
	"./ambassadors/step-1.svg": "5d72",
	"./ambassadors/step-2.svg": "bf4d",
	"./ambassadors/step-3.svg": "aba4",
	"./ambassadors/step1.svg": "f5bf",
	"./ambassadors/step2.svg": "63e1",
	"./ambassadors/step3.svg": "43bd",
	"./arrow-left-vector.svg": "504a",
	"./bank-connection-failure.png": "36a5",
	"./bank-connection-success.png": "d01a",
	"./bank-logos-30/CCAMX45.png": "b1b4",
	"./bank-logos-30/CCCal45.png": "8957",
	"./bank-logos-30/CCIsracard45.png": "7fa3",
	"./bank-logos-30/CCLeumi45.png": "f8d6",
	"./bank-logos-30/Yahav45.png": "f8c0",
	"./bank-logos-30/amex-large.svg": "5220",
	"./bank-logos-30/cal-diners.svg": "4a11",
	"./bank-logos-30/discount.svg": "2b32",
	"./bank-logos-30/doar.svg": "1562",
	"./bank-logos-30/egud.svg": "2ea7",
	"./bank-logos-30/habeinleumi.svg": "37c7",
	"./bank-logos-30/hapoalim.svg": "4171",
	"./bank-logos-30/isracard-logo.png": "8829",
	"./bank-logos-30/leumi.svg": "d191",
	"./bank-logos-30/leumicard-max.png": "12c5",
	"./bank-logos-30/massad.svg": "ebc9",
	"./bank-logos-30/mercantile.png": "072a",
	"./bank-logos-30/mizrachi.svg": "c2ee",
	"./bank-logos-30/otsar.png": "ccf8",
	"./bank-logos-30/pagi.png": "3f54",
	"./bank-logos-30/pepper-large.svg": "eba3",
	"./bank-logos-30/ubank.png": "f8a7",
	"./bank-logos-45/BankPoalim45.png": "3960",
	"./bank-logos-45/CCAMX45.png": "dfe1",
	"./bank-logos-45/CCCal45.png": "45ec",
	"./bank-logos-45/CCIsracard45.png": "3f1f",
	"./bank-logos-45/CCLeumi45.png": "89d3",
	"./bank-logos-45/Discount45.png": "537f",
	"./bank-logos-45/Doar45.png": "906b",
	"./bank-logos-45/Egood45.png": "3a1d",
	"./bank-logos-45/Habenleumi45.png": "f7c3",
	"./bank-logos-45/Hayal45.png": "ee41",
	"./bank-logos-45/Jerusalem45.png": "e3fa",
	"./bank-logos-45/Leumi45.png": "19b1",
	"./bank-logos-45/Masad45.png": "df06",
	"./bank-logos-45/Mercantil45.png": "aba9",
	"./bank-logos-45/Mizrahi45.png": "a718",
	"./bank-logos-45/Pegi45.png": "f2a0",
	"./bank-logos-45/Pepper45.png": "a33f",
	"./bank-logos-45/UBank45.png": "3c1d",
	"./bank-logos-45/Yahav45.png": "beeb",
	"./bank-logos/amex-large.svg": "c55a",
	"./bank-logos/amex-stacked.png": "346c",
	"./bank-logos/amex-stacked.svg": "e2f7",
	"./bank-logos/amex.jpg": "766c",
	"./bank-logos/blue-redirect-info-icon.svg": "9c44",
	"./bank-logos/cal-diners-stacked.png": "4514",
	"./bank-logos/cal-diners-stacked.svg": "3c6a",
	"./bank-logos/cal-diners.svg": "4b03",
	"./bank-logos/cal-stacked.png": "be37",
	"./bank-logos/cal.jpg": "583b",
	"./bank-logos/discount-large.svg": "1d0a",
	"./bank-logos/discount-small.svg": "79f8",
	"./bank-logos/discount.jpg": "4511",
	"./bank-logos/doar-large.svg": "c5cd",
	"./bank-logos/doar-small.svg": "0783",
	"./bank-logos/doar.jpg": "e7ed",
	"./bank-logos/egud.jpg": "7b57",
	"./bank-logos/habeinleumi-large.svg": "ab7d",
	"./bank-logos/habeinleumi-small.svg": "7ac4",
	"./bank-logos/habenleumi.jpg": "c6b0",
	"./bank-logos/hapoalim-large.svg": "d4ce",
	"./bank-logos/hapoalim-small.svg": "a473",
	"./bank-logos/igud-large.svg": "6bec",
	"./bank-logos/igud-small.svg": "551e",
	"./bank-logos/isracard-large.svg": "fbec",
	"./bank-logos/isracard-logo.png": "150c",
	"./bank-logos/isracard-stacked.svg": "d1f8",
	"./bank-logos/isracard.jpg": "c8d2",
	"./bank-logos/jerusalem-large.jpg": "71d9",
	"./bank-logos/jerusalem.jpg": "8af7",
	"./bank-logos/leumi-large.svg": "bdb6",
	"./bank-logos/leumi-obk-small.svg": "e3ad",
	"./bank-logos/leumi-small.svg": "1031",
	"./bank-logos/leumi.jpg": "81cc",
	"./bank-logos/leumicard-max-stacked.png": "4048",
	"./bank-logos/leumicard-max.png": "356f",
	"./bank-logos/leumicard-stacked.png": "6693",
	"./bank-logos/leumicard.jpg": "aa7b",
	"./bank-logos/masad.jpg": "cc52",
	"./bank-logos/massad-large.svg": "d1d6",
	"./bank-logos/massad-small.svg": "2acf",
	"./bank-logos/max-leumi-stacked.svg": "b445",
	"./bank-logos/meitav.svg": "bf8f",
	"./bank-logos/mercantil.jpg": "10b7",
	"./bank-logos/mercantile-large.png": "da94",
	"./bank-logos/mercantile-small@3x.jpg": "c310",
	"./bank-logos/mizrachi-large.svg": "9f7f",
	"./bank-logos/mizrachi-small.svg": "ec1e",
	"./bank-logos/mizrahi.jpg": "7f17",
	"./bank-logos/one-zero.png": "c0ce",
	"./bank-logos/otsar-large.jpg": "2649",
	"./bank-logos/otsar-large.png": "f708",
	"./bank-logos/otzarhahayal.jpg": "e326",
	"./bank-logos/pagi-large.png": "7c8f",
	"./bank-logos/pagi.jpg": "d13a",
	"./bank-logos/pepper-badge-large.svg": "5ee0",
	"./bank-logos/pepper-large.svg": "5a01",
	"./bank-logos/pepper-redirect-info-icon.svg": "ee94",
	"./bank-logos/pepper.png": "1c10",
	"./bank-logos/poalim.jpg": "5817",
	"./bank-logos/ubank-large.png": "e612",
	"./bank-logos/ubank.jpg": "cd0a",
	"./bank-logos/yahav-large.jpg": "d504",
	"./bank-logos/yahav-new-large.png": "eb5f",
	"./bank-logos/yahav.jpg": "a85b",
	"./banners/blue-shapes-with-logo.svg": "7888",
	"./black-and-white-pot.png": "3582",
	"./black-and-white-snapping-finger.png": "9309",
	"./blue-flower-card.svg": "d3db",
	"./blue-pencil.svg": "4703",
	"./blue-x.svg": "3c32",
	"./bot.png": "9ded",
	"./botprofile@3x.jpg": "85d7",
	"./cards/amex.png": "7543",
	"./cards/cal.png": "a8d5",
	"./cards/diners_visacal.png": "8c29",
	"./cards/isracard.png": "34e0",
	"./cards/leumicard.png": "d175",
	"./cashflow-locked.svg": "1a8b",
	"./cashflow-start-day-walkthrough/1 to 9/cashflow-after-change.svg": "2757",
	"./cashflow-start-day-walkthrough/1 to 9/current-cashflow.svg": "572f",
	"./cashflow-start-day-walkthrough/1 to 9/expenses.svg": "feaa",
	"./cashflow-start-day-walkthrough/1 to 9/incomes-1.svg": "cb3b",
	"./cashflow-start-day-walkthrough/1 to 9/incomes-2.svg": "1924",
	"./cashflow-start-day-walkthrough/1 to 9/indent-explanation.svg": "6738",
	"./cashflow-start-day-walkthrough/10 to end of month/cashflow-after-change.svg": "85a5",
	"./cashflow-start-day-walkthrough/10 to end of month/current-cashflow.svg": "74f5",
	"./cashflow-start-day-walkthrough/10 to end of month/expenses.svg": "fa1a",
	"./cashflow-start-day-walkthrough/10 to end of month/incomes-1.svg": "2c6d",
	"./cashflow-start-day-walkthrough/10 to end of month/incomes-2.svg": "b544",
	"./cashflow-start-day-walkthrough/10 to end of month/indent-explanation.svg": "ad15",
	"./cashflow-start-day-walkthrough/calendar-cashflow/1 to 9-cashflow-after-change.svg": "7b2f",
	"./cashflow-start-day-walkthrough/calendar-cashflow/1 to 9-incomes-and-expenses.svg": "c7bd",
	"./cashflow-start-day-walkthrough/calendar-cashflow/10 to end of month-cashflow-after-change.svg": "1ac2",
	"./cashflow-start-day-walkthrough/calendar-cashflow/10 to end of month-incomes-and-expenses.svg": "06b0",
	"./cashflow-start-day-walkthrough/calendar-cashflow/current-cashflow.svg": "775b",
	"./cashflow-start-day-walkthrough/calendar.svg": "89bf",
	"./cc-example.svg": "6bc5",
	"./celebrating-hands-drawing.png": "d3ac",
	"./challenge/Ellipse.svg": "3d89",
	"./challenge/RoundBottom.svg": "62a6",
	"./challenge/RoundBottomWhite.svg": "442b",
	"./challenge/active-challenge.svg": "7ee7",
	"./challenge/active-monthly-goal.svg": "cae4",
	"./challenge/blue-v.svg": "41d6",
	"./challenge/blue-x.svg": "851d",
	"./challenge/burger.svg": "9958",
	"./challenge/burrito.svg": "f594",
	"./challenge/croissant.svg": "1336",
	"./challenge/donut.svg": "62cb",
	"./challenge/fries.svg": "c5e8",
	"./challenge/green-v.svg": "ffb7",
	"./challenge/heart-icon.svg": "abc8",
	"./challenge/iceCream.svg": "5739",
	"./challenge/loties/Challenge-confeti": "cacc",
	"./challenge/loties/Challenge-confeti.json": "cacc",
	"./challenge/loties/Conffetti 02": "762c",
	"./challenge/loties/Conffetti 02.json": "762c",
	"./challenge/loties/Fail-ripple": "b606",
	"./challenge/loties/Fail-ripple.json": "b606",
	"./challenge/loties/Succsess-ripple": "9d73",
	"./challenge/loties/Succsess-ripple.json": "9d73",
	"./challenge/pitta.svg": "67d0",
	"./challenge/pizza.svg": "f483",
	"./challenge/pretzel.svg": "f033",
	"./challenge/red-x.svg": "2120",
	"./challenge/riseup-badge.svg": "cad4",
	"./challenge/sandwich.svg": "820d",
	"./challenge/takeout.svg": "60cb",
	"./check-green-happy.svg": "2e88",
	"./check-with-green-circle.svg": "65e7",
	"./checkbox-blue-marked.svg": "6508",
	"./churn/churn-icon.svg": "7d65",
	"./close-toaster.svg": "8244",
	"./close_icon.svg": "e258",
	"./coin-pile-drawing.png": "f5c5",
	"./comments.svg": "f7e7",
	"./crown.png": "370f",
	"./cx-avatars/guy-avatar@3x.png": "7cae",
	"./cx-avatars/nofar-avatar@3x.png": "a8e9",
	"./cx-avatars/yael-avatar@3x.png": "026d",
	"./demo/group.png": "5f73",
	"./demo/one_number.png": "ce5f",
	"./demo/prev_months.png": "47aa",
	"./demo/slide-1-image@3x.jpg": "7b1d",
	"./demo/slide-2-image@3x.jpg": "8ea9",
	"./demo/slide-3-image@3x.jpg": "76d0",
	"./demo/slide-4-image@3x.jpg": "6aa9",
	"./demo/transactions.png": "2a37",
	"./discount-riseup-friends.svg": "20ae",
	"./dormant/short-term-dormant-default.png": "dc6d",
	"./dormant/short-term-dormant-months-free.png": "e043",
	"./dormant/short-term-dormant-percentage.png": "d247",
	"./down-full-arrow.svg": "bbff",
	"./dynamic-deposit/authenticated-shapes.svg": "57b4",
	"./dynamic-deposit/celebrate": "1b16",
	"./dynamic-deposit/celebrate-share.png": "75ff",
	"./dynamic-deposit/celebrate-share.svg": "0a3c",
	"./dynamic-deposit/celebrate.json": "1b16",
	"./dynamic-deposit/error-page.svg": "3cf3",
	"./dynamic-deposit/non-authenticated-shapes.svg": "3e73",
	"./dynamic-deposit/progress-bar/authentication.svg": "435c",
	"./dynamic-deposit/progress-bar/choose-amount.svg": "bde6",
	"./dynamic-deposit/progress-bar/detailes.svg": "9295",
	"./dynamic-deposit/progress-bar/signature.svg": "c9f8",
	"./dynamic-deposit/shapes.svg": "588e",
	"./end-of-year/eoy-popup.svg": "8cd1",
	"./end-of-year/eoy.png": "3c7f",
	"./end-of-year/eoy.svg": "42c8",
	"./end-of-year/flower.svg": "f6e4",
	"./end-of-year/gift.svg": "a00d",
	"./end-of-year/tooltip.png": "c0e1",
	"./error_icon.svg": "5c67",
	"./errors/fallen-flower-pot.png": "a234",
	"./exceeding-variables-bar.svg": "87a0",
	"./exclamation-mark@3x.png": "7ab3",
	"./fb-icon.svg": "3b33",
	"./financial-success.png": "733b",
	"./generic-faliure.png": "7eea",
	"./generic-success.png": "30ca",
	"./goal-circle-disabled.svg": "60ce",
	"./goal-circle.svg": "b2a4",
	"./great-success.png": "7795",
	"./grey-pencil.svg": "89db",
	"./group-7@3x.png": "ee2d",
	"./group-cx@3x.png": "8790",
	"./group@3x.jpg": "1dd5",
	"./half-round-header-background.svg": "5bb0",
	"./happy-star-drawing.png": "2de4",
	"./help-outline@3x.png": "48e1",
	"./hero-login.svg": "1b2c",
	"./hever/header_hever.svg": "cc3c",
	"./high-five-hands-drawing.png": "257a",
	"./how-much.png": "e7dd",
	"./icon-info.svg": "d399",
	"./icon-lock.svg": "85d1",
	"./icons/account_balance_24dp.svg": "ac2c",
	"./icons/add-disabled.svg": "7450",
	"./icons/add.svg": "76a4",
	"./icons/alert-icon.svg": "dd45",
	"./icons/arrow-down.svg": "c874",
	"./icons/arrow-left.svg": "ac3b",
	"./icons/arrow-white.svg": "0e6c",
	"./icons/arrow_disabled_left.svg": "b1e9",
	"./icons/arrow_disabled_right.svg": "e7d5",
	"./icons/arrow_enabled_left.svg": "cf74",
	"./icons/arrow_enabled_right.svg": "1841",
	"./icons/assignment-ind.svg": "aac4",
	"./icons/bank-icon.svg": "69d2",
	"./icons/better-v.svg": "13eb",
	"./icons/blacktrash.svg": "5222",
	"./icons/broken-link-icon.svg": "27f8",
	"./icons/challenge-action.svg": "409f",
	"./icons/chat_icon_dark_green.svg": "68d2",
	"./icons/chat_icon_secondary.svg": "ee6b",
	"./icons/chat_icon_small.svg": "bafd",
	"./icons/chat_icon_small_teriatry.svg": "0278",
	"./icons/chat_icon_small_white.svg": "e27d",
	"./icons/chat_icon_teriatry.svg": "e1cf",
	"./icons/chat_icon_teriatry_white.svg": "9d96",
	"./icons/check-green-icon.svg": "397b",
	"./icons/check-light-blue.svg": "1918",
	"./icons/check-list.svg": "54a4",
	"./icons/check_mark.svg": "734d",
	"./icons/checkmark-blue-little.svg": "a1be",
	"./icons/close-fat.svg": "fd8e",
	"./icons/close-white.svg": "72e4",
	"./icons/close.svg": "8b1b",
	"./icons/clover-check-mark.svg": "76ef",
	"./icons/comment.svg": "c47d",
	"./icons/credit-card-icon-disabled.svg": "fbbb",
	"./icons/credit-card-icon.svg": "ceab",
	"./icons/credit-card-outline.svg": "0535",
	"./icons/credit-card.svg": "98dc",
	"./icons/credit_card_24dp.svg": "6a6f",
	"./icons/credit_card_24dp_gray.svg": "9089",
	"./icons/discount-icon.svg": "c2ab",
	"./icons/dome-check-mark.svg": "800f",
	"./icons/edit-prediction.svg": "844e",
	"./icons/edits-exclude.svg": "7f39",
	"./icons/edits-is-savings.svg": "8e5a",
	"./icons/edits-move.svg": "6a40",
	"./icons/edits-not-savings.svg": "be78",
	"./icons/edits-sub-category.svg": "08e2",
	"./icons/edits-trash.svg": "dd9b",
	"./icons/event.svg": "e5b3",
	"./icons/exclamation-mark.svg": "379f",
	"./icons/exclemation-mark-blue.svg": "702f",
	"./icons/exclemation-mark-coral.svg": "8205",
	"./icons/exclemation-mark-gray.svg": "a2a7",
	"./icons/exclemation-mark-red.svg": "839f",
	"./icons/exclemation-mark-yellow.svg": "d94a",
	"./icons/expand-arrow-down-medium-disabled.svg": "f37d",
	"./icons/expand-arrow-down-medium.svg": "a22a",
	"./icons/expand-arrow-down-small-disabled.svg": "4c2c",
	"./icons/expand-arrow-down-small.svg": "d9f8",
	"./icons/flag-grey.svg": "1d60",
	"./icons/flag.svg": "c26e",
	"./icons/gift.svg": "fb5c",
	"./icons/graph-bars.svg": "d17d",
	"./icons/graph-line.svg": "43c8",
	"./icons/gray-pencil.svg": "cffd",
	"./icons/green-gift.svg": "e573",
	"./icons/group-5.svg": "c92d",
	"./icons/hands_raised.png": "3668",
	"./icons/heart-icon.svg": "267f",
	"./icons/heart.svg": "7d16",
	"./icons/ic-close.svg": "d41d",
	"./icons/icon-check-blue.svg": "8894",
	"./icons/icon-lock-gray.svg": "2202",
	"./icons/icon_add.svg": "45f6",
	"./icons/icon_add_member.svg": "a2bb",
	"./icons/icon_edit.svg": "b919",
	"./icons/icon_left_arrow.svg": "2951",
	"./icons/icon_supermarket.svg": "6682",
	"./icons/info-icon-blue.svg": "75fa",
	"./icons/info-icon-grey.svg": "b2d7",
	"./icons/left-triangle.svg": "3eed",
	"./icons/light-three-dots.svg": "0c5d",
	"./icons/location-marker.svg": "dee5",
	"./icons/lock-blue.svg": "b47b",
	"./icons/lock-grey.svg": "a7d1",
	"./icons/lock-outline.svg": "5994",
	"./icons/menu-white.svg": "f800",
	"./icons/menu.svg": "d17f",
	"./icons/missing-card.svg": "04e0",
	"./icons/modal-close-blue.svg": "0158",
	"./icons/modal-close-mustard.svg": "3d49",
	"./icons/mode-edit.svg": "af9c",
	"./icons/next-month-triangle.svg": "d602",
	"./icons/notice-gray.svg": "c521",
	"./icons/notice-green.png": "4986",
	"./icons/orange-x.svg": "d125",
	"./icons/pending.svg": "e25a",
	"./icons/phone-vector.svg": "df8d",
	"./icons/pink-flower.svg": "9a2e",
	"./icons/present.svg": "4577",
	"./icons/previous-month-triangle.svg": "916e",
	"./icons/profile/secondary-4.svg": "0422",
	"./icons/question-mark-icon.svg": "2749",
	"./icons/redtrash.svg": "7fc3",
	"./icons/remove.svg": "5088",
	"./icons/right-triangle.svg": "b750",
	"./icons/sad-smiley-blue.svg": "494e",
	"./icons/sad-smiley-grey.svg": "74f1",
	"./icons/savings-not-fixed.svg": "45eb",
	"./icons/savings-not-variable.svg": "e2b9",
	"./icons/search-grey.svg": "9d9a",
	"./icons/search-vector.svg": "0c46",
	"./icons/search.svg": "d103",
	"./icons/small_check.svg": "b78e",
	"./icons/smiling-smiley-blue.svg": "aa83",
	"./icons/smiling-smiley-grey.svg": "1d59",
	"./icons/split.svg": "c716",
	"./icons/star-check-mark.svg": "c4d6",
	"./icons/star-white.svg": "5c31",
	"./icons/success-icon.svg": "13a1",
	"./icons/temp_transaction_large.svg": "5492",
	"./icons/temp_transaction_small.svg": "8c97",
	"./icons/three-dots.svg": "0960",
	"./icons/thumbs-down.svg": "9a65",
	"./icons/thumbs-up.svg": "fe9c",
	"./icons/trash.svg": "af22",
	"./icons/unknown-error.png": "c2bd",
	"./icons/v-blue.svg": "3fe6",
	"./icons/v-outline-filled-pink.svg": "0945",
	"./icons/v-outline.svg": "bf62",
	"./icons/v-white.svg": "7dc7",
	"./icons/verified.svg": "256c",
	"./icons/vertical-three-dots.svg": "6bbd",
	"./icons/video-icon-blue.svg": "7753",
	"./icons/wallet-vector.svg": "d460",
	"./icons/warning-icon.svg": "209f",
	"./icons/whatsapp-icon.svg": "1f60",
	"./icons/white-pencil.svg": "b21d",
	"./icons/white-trash.svg": "c8e1",
	"./icons/yellow-sun.svg": "25b9",
	"./im-on-it/100days-signup-header.svg": "e0c2",
	"./im-on-it/im-on-it-card-header-text.svg": "5c08",
	"./intercom_chat_icon.svg": "3529",
	"./intercom_chat_icon_primary.svg": "2b74",
	"./introduction/emun.png": "a467",
	"./introduction/intro_image_new_smaller.png": "f0cf",
	"./investigation_vis.svg": "94c1",
	"./invite-member-message.png": "4ec4",
	"./invite-member-top.png": "f841",
	"./invite-member.png": "bf3d",
	"./invite-member.svg": "7006",
	"./leumi_riseup_friends.svg": "6830",
	"./lock.svg": "3c1a",
	"./lock_done.svg": "981f",
	"./lock_green.png": "b31d",
	"./lock_icon.svg": "c790",
	"./logo-horizontal-green.svg": "5cd3",
	"./logo-horizontal-white.svg": "ab7e",
	"./logo-vertical-yellow.svg": "34bf",
	"./logo-vertical.svg": "ff18",
	"./mid-month/confetti.svg": "8738",
	"./mid-month/left.svg": "37ea",
	"./mid-month/month-sticker.svg": "72bc",
	"./mid-month/mute.svg": "6c32",
	"./mid-month/next-arrow-cool.svg": "b8cc",
	"./mid-month/real-price-hashtag.svg": "ec64",
	"./mid-month/restart.svg": "3d9f",
	"./mid-month/right-blue.svg": "97e9",
	"./mid-month/right.svg": "0cee",
	"./mid-month/share-logo.svg": "5371",
	"./mid-month/star-green.svg": "c654",
	"./mid-month/star-red.svg": "6991",
	"./mid-month/supermarket/average-bottom-arrow.svg": "22ca",
	"./mid-month/supermarket/average-top-arrow.svg": "21ac",
	"./mid-month/supermarket/boxing-gloves.gif": "7991",
	"./mid-month/supermarket/eggs.gif": "124c",
	"./mid-month/supermarket/food-bowl.gif": "9e83",
	"./mid-month/supermarket/guy-with-shopping-cart.gif": "76c3",
	"./mid-month/supermarket/location-orange.svg": "3f36",
	"./mid-month/supermarket/location-pink.svg": "6dc6",
	"./mid-month/supermarket/location-yellow.svg": "9873",
	"./mid-month/supermarket/next-story-page-arrow.svg": "518a",
	"./mid-month/supermarket/shopping-cart.gif": "20a6",
	"./mid-month/supermarket/tomato.gif": "ae3a",
	"./mid-month/supermarket/trophy.gif": "e2c5",
	"./mid-month/testimonials.png": "45b3",
	"./mid-month/unmute.svg": "b52e",
	"./money-moon/money-moon-join-header.svg": "9ab1",
	"./no-overdraft.png": "be60",
	"./no-results-drawing.png": "fbe9",
	"./ntd/ntd-banner.png": "bbdd",
	"./ntd/ntd-popup.svg": "8e46",
	"./obk-arrow.svg": "10a1",
	"./onboarding-discount.png": "aec4",
	"./open-link-button.svg": "3d3a",
	"./oval@3x.png": "e8fe",
	"./paybox-challenge/calculator-background.svg": "d337",
	"./paybox-challenge/paybox-no-recommendation.png": "c0a0",
	"./paybox-challenge/paybox-welcome.png": "565d",
	"./paybox-challenge/riseup_plus_paybox.svg": "0b14",
	"./payment/payment.svg": "c018",
	"./pc-no-support-icon.svg": "0fbf",
	"./pencil.svg": "33bf",
	"./pending-icon.svg": "4a6d",
	"./pink-flower-card.svg": "67360",
	"./promotions/21-days/21-days-promo-header.png": "10cf",
	"./promotions/21-days/21-days-promo-welcome-header.png": "a659",
	"./promotions/aleph/aleph-header.svg": "d63e",
	"./promotions/alljobs/alljobs-2-mo-image.png": "2c25",
	"./promotions/alljobs/alljobs-3-mo-image.png": "d0cf",
	"./promotions/alljobs/alljobs-welcome.png": "70f2",
	"./promotions/ashmoret/ashmoret_header.svg": "dfe5",
	"./promotions/bat-yam/batyam-header.png": "bf73",
	"./promotions/bat-yam/batyam-header.svg": "3b73",
	"./promotions/discount/discont_welcome_header.png": "9d3e",
	"./promotions/discount/discount-header.svg": "991b",
	"./promotions/discount/discount-riseup.svg": "1b12",
	"./promotions/discount/discount_welcome_header_new.png": "0509",
	"./promotions/friends/friends-header.png": "59bc",
	"./promotions/friends/friends-welcome-header.png": "3305",
	"./promotions/generic-signup-header.png": "5919",
	"./promotions/generic-welcome-header.png": "d909",
	"./promotions/harel/harel-header.png": "81ed",
	"./promotions/harel/harel-welcome-header.png": "f09a",
	"./promotions/hayanshuf/hayanshuf-header.svg": "fdab",
	"./promotions/hever/hever-header.png": "9aff",
	"./promotions/hever/hever-welcome-header.png": "3c9c",
	"./promotions/isracard/isracard-header.svg": "66f9",
	"./promotions/isracard/isracard-welcome-header.png": "0c0e",
	"./promotions/jerusalem/jerusalem-header.svg": "0e09",
	"./promotions/limited-time-offer-banner.svg": "82a3",
	"./promotions/moneymoon.svg": "e853",
	"./promotions/netafim/netafim_header.png": "93f3",
	"./promotions/nevo/nevo_header.svg": "5a39",
	"./promotions/new-credit/new-credit.jpg": "1954",
	"./promotions/new-credit/newcredit_header.svg": "32c8",
	"./promotions/percentage-discount/ariel-welcome.png": "8c32",
	"./promotions/percentage-discount/ariel.png": "d070",
	"./promotions/percentage-discount/trima-welcome.png": "ebac",
	"./promotions/percentage-discount/trima.png": "dd4b",
	"./promotions/percentage-discount/yes-welcome.png": "a27e",
	"./promotions/percentage-discount/yes.png": "3e76",
	"./promotions/promo-popup-image.svg": "e98c",
	"./promotions/promotion-expired.svg": "1a43",
	"./promotions/tarya/tarya-header.svg": "7ba2",
	"./promotions/yahav/yahav-signup.png": "3c54",
	"./rainbow-pink-yellow-red.svg": "4405",
	"./rainbow.svg": "0bee",
	"./red-eight-pointed-alert-flower.svg": "a058",
	"./regulations-arrow.svg": "3911",
	"./remove-disabled.svg": "c046",
	"./riseup-giftcard/purchase_done.svg": "6036",
	"./riseup-giftcard/upsell-asset.png": "3407",
	"./riseup_logo.svg": "c442",
	"./rolling-credit-vis.svg": "e227",
	"./round-header-background.svg": "3dab",
	"./search-drawing.png": "4fb1",
	"./share-popup/download.svg": "1de2",
	"./share-popup/expand_more.svg": "241f",
	"./share-popup/share.svg": "fd2e",
	"./share_black_icon.svg": "1dca",
	"./share_white_icon.svg": "7d84",
	"./snapping-fingers-drawing.png": "8603",
	"./story-backgrounds/blue-white.png": "5fc7",
	"./story-backgrounds/cashflowy.png": "a8c6",
	"./story-backgrounds/default.png": "83f3",
	"./story-backgrounds/expensive-day.png": "6bcd",
	"./story-backgrounds/november.png": "ca82",
	"./story-backgrounds/real-price-hashtag.svg": "3df7",
	"./story-backgrounds/vacation.png": "e4b2",
	"./story-backgrounds/wedding.png": "40ef",
	"./story-backgrounds/worldcup.png": "3d45",
	"./story-backgrounds/worth-it.png": "df86",
	"./subdirectory-arrow-left@3x.png": "a3d3",
	"./subscription-cta/cta-no-promo.png": "9d8b",
	"./subscription-cta/promo-sub-cta.png": "c929",
	"./subscription/account-settings-header.svg": "f8f1",
	"./subscription/after-payment-header.svg": "4661",
	"./subscription/checkout_header.svg": "7a32",
	"./subscription/credit-card-header.svg": "9029",
	"./subscription/discount.svg": "2a4d",
	"./subscription/edit_icon.svg": "f7e75",
	"./subscription/flow.png": "f279",
	"./subscription/header.svg": "148f",
	"./subscription/money-back-guarantee-header.svg": "fd1d",
	"./subscription/oval-green.png": "47dd",
	"./subscription/oval-mustard.png": "96e3",
	"./subscription/personal-info.png": "ea56",
	"./subscription/riseup-icon.png": "84fc",
	"./subscription/subscribe_header.svg": "89a2",
	"./subscription/subscription-discount-10nis.png": "66bb",
	"./subscription/subscription-type-header.svg": "86dc",
	"./subscription/success.png": "3caf",
	"./subscription/sun.svg": "24b1",
	"./subscription/thnaks_for_subscribing_header.svg": "5497",
	"./sun.svg": "3f73",
	"./sun2.svg": "bd6c",
	"./sun3.svg": "c46d",
	"./sun4.svg": "6b8e",
	"./super-discount/all-logos-new.png": "d45e",
	"./super-discount/all-logos.png": "ea48",
	"./super-discount/carrefour.png": "362f",
	"./super-discount/carrefour/card-logo.svg": "ca52",
	"./super-discount/carrefour/carrefour-logos.png": "cbc3",
	"./super-discount/carrefour/discount.svg": "b6fe",
	"./super-discount/cart.png": "d3d0",
	"./super-discount/groceries.png": "9889",
	"./super-discount/rami-logo.png": "a463",
	"./super-discount/rami/card-logo.svg": "73f4",
	"./super-discount/rami/discount.svg": "d60c",
	"./super-discount/rami/rami-logos.png": "9fe4",
	"./super-discount/super1.png": "70db",
	"./super-discount/super2.png": "cbdd",
	"./super-discount/super3.png": "6079",
	"./super-discount/super4.png": "442a",
	"./super-discount/super5.png": "a4c3",
	"./super-discount/super6.png": "4646",
	"./super-discount/thumbsup.png": "f82e",
	"./testpng.png": "d76b",
	"./tracking-categories/car.png": "19fe",
	"./tracking-categories/clothing.png": "7ffe",
	"./tracking-categories/donation.png": "691a",
	"./tracking-categories/food.png": "1853",
	"./tracking-categories/leisure.png": "0bb8",
	"./tracking-categories/other.png": "4abe",
	"./tracking-categories/pets.png": "dacf",
	"./tracking-categories/pharma.png": "e3e1",
	"./tracking-categories/public-transportation.png": "5228",
	"./tracking-categories/super.png": "7d32",
	"./tracking-categories/tourism.png": "8abc",
	"./tracking-categories/tracking-categories-no-selection.svg": "96e9",
	"./trusted.png": "cff1",
	"./unchecked-circle.svg": "c7e4",
	"./whatsapp-icon.svg": "d117",
	"./whatsapp-optin.jpg": "2a32",
	"./whatsapp.svg": "3357",
	"./wine-and-dine/CX.png": "6be4",
	"./wine-and-dine/cover-image@3x.png": "c158",
	"./wine-and-dine/financial_advice_faces@2x.png": "d3db8",
	"./wine-and-dine/money-question@3x.png": "e268",
	"./wine-and-dine/other-products-intorduction/full-image.png": "b5bf",
	"./wine-and-dine/other-products-intorduction/introduction.png": "3b9a",
	"./wine-and-dine/other-products-intorduction/one-month-free.svg": "7abd",
	"./wine-and-dine/other-products-intorduction/organized-categories.png": "643f",
	"./wine-and-dine/other-products-intorduction/personalize-categories.png": "684f",
	"./wine-and-dine/other-products-intorduction/reducible-expenses.png": "d778",
	"./wine-and-dine/trial-explanation-star.svg": "c55b",
	"./xnes/checkmark-blue-round-background.svg": "2df0",
	"./xnes/dashboard-logo.svg": "a257",
	"./xnes/vertical-progress.svg": "9576",
	"./xnes/xnes-intro.svg": "878e",
	"./xnes/xnes-progress-page.svg": "ce27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";